module.exports = {"TXTCLI_Amount":{"id":"TXTCLI_Amount","defaultMessage":"Beløb","track":"Amount"}}